var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showForm)?_c('div',{class:_vm.hidden && 'zero'},[_c('generate-form',{ref:"generateForm",attrs:{"data":_vm.data,"remote":_vm.remoteFunc,"remote-option":_vm.dynamicData,"scriptforge-endpoint":_vm.scriptforgeEndpoint},on:{"on-change":_vm.onChange,"on-input-change":_vm.onInputChange}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }